<template>
  <aside>
    <div class="sidebar">
      <div class="nav">
        <el-menu text-color="#fff" active-text-color="#ffd04b" @select="sidebarSelect" :default-active="activeIndex">
          <template v-for="(item,index) in menu">
            <el-menu-item :key="index" :index="item.title"
              v-if="!(item.title==='用户管理'&&$store.getters[gettersType.GET_LNG]=='en-US')">
              <i :class="item.icon"></i>
              <!-- <span slot="title">{{$store.getters[gettersType.GET_LNG]}}</span> -->
              <span slot="title">{{item.title}}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </div>
    </div>
  </aside>
</template>
<script>
import * as gettersType from '@/store/getters/type';
import { zhURL } from '@/config/index';
import { sessionStorage } from '@/common/util/storage';
export default {
  data() {
    return {
      gettersType,
      sessionStorage,
      delayTime: 200,
      activeIndex: '图文管理',
      menu: [
        {
          title: '图文管理',
          enable: true,
          icon: 'fa fa-bar-chart fa-lg',
          children: []
        },
        {
          title: '综合管理',
          enable: true,
          icon: 'fa fa-sign-language fa-lg',
          children: []
        },
        {
          title: '产品管理',
          enable: true,
          icon: 'fa fa-gear fa-lg',
          children: []
        },
        // {
        //   title: '系统设置',
        //   enable: true,
        //   icon: 'fa fa-gear fa-lg',
        //   children: []
        // },
        {
          title: '用户管理',
          enable: true,
          icon: 'fa fa-group fa-lg',
          children: []
        }
        // {
        //   title: '操作日志',
        //   enable: true,
        //   icon: 'fa fa-link fa-lg',
        //   children: []
        // }
      ]
    };
  },
  computed: {},
  methods: {
    validatePopedom() {},
    sidebarSelect(key, keyPath, event) {
      this.$router.push({ path: `${zhURL[key]}` });
    }
  }
};
</script>
<style lang="stylus" scoped></style>



// WEBPACK FOOTER //
// src/pages/adminCenter/area/sidebar.vue